<script lang="ts" setup>
import { SortMenuItem } from '@/types';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const sortMenuItems = ref([
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.name'),
        key: 'name',
    },
    {
        label: t('report.realtimeAgentExtension.sortMenu.items.extension'),
        key: 'extension',
    },
] as SortMenuItem[]);

const props = defineProps({
    modelValue: {
        type: Array<SortMenuItem>,
    },
});

const emit = defineEmits(['update:modelValue']);

const updateValue = (value: SortMenuItem[]) => {
    emit('update:modelValue', value.slice(-1));
};
</script>

<template>
    <UiSortMenu
        :items="sortMenuItems"
        :model-value="props.modelValue"
        fixmobile
        @update:modelValue="updateValue"
    />
</template>
